import api from 'api-client'

const state = {
    partnerDetailsContact: { name: '', mobile: '', email: '' },
}

const getters = {
    partnerDetailsContact: state => state.partnerDetailsContact,
}

const mutations = {
    setPartnerDetailsContact(state, partnerDetailsContact) {
        state.partnerDetailsContact = partnerDetailsContact
    }
}

const actions = {
    updateUserDetailsContact({ dispatch }, partnerDetailsContact) {
        return api.updateUserDetailsContact(partnerDetailsContact)
            .then(async () => {
                const user = await api.me();
                dispatch('setUser', user)
            })
    },

}

export default {
    state, getters, mutations, actions
}
